import {PRIVACY_TOKEN_CONFIRMATION} from "../constants/index"

// Extend the Window interface to include __conf__
declare global {
  interface Window {
    __conf__: Record<string, any>;
  }
}

const { VITE_REQUEST_INFORMATION = "" } = window.__conf__ || {}; 
export interface PrivacyOptPayloadInput {
  emailValue: string;
}

export interface PrivacyOptPayload {
  identifier: string;
  requestInformation: string;
  purposes: Array<{
    Id: string;
    TransactionType: string;
  }>;
}


export const privacyOptPayload = (emailValue: string): PrivacyOptPayload => {
  return {
    identifier: emailValue,
    requestInformation: VITE_REQUEST_INFORMATION,
    purposes: [
      {
        Id: import.meta.env.VITE_PURPOSES_ID,
        TransactionType: PRIVACY_TOKEN_CONFIRMATION,
      },
    ],
  };
};

export interface GetCookie {
    (name: string): string | null;
}

export const getCookie: GetCookie = (name) => {
    const cookieString = document.cookie;
    const cookies = cookieString.split(';');

    for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i].trim(); // Remove leading/trailing whitespace

        // Check if this cookie starts with the desired name followed by an equals sign
        if (cookie.startsWith(name + '=')) {
            // Extract and decode the cookie value
            return decodeURIComponent(cookie.substring(name.length + 1));
        }
    }
    return null; // Return null if the cookie is not found
}

export interface SetCookieOptions {
    path?: string;
    domain?: string;
}

export const setCookie = (
    name: string,
    value: string,
    expireMins: number,
    path: string = "",
    domain: string = ""
): void => {
    const d = new Date();
    d.setTime(d.getTime() + expireMins * 60 * 1000);
    const expires = `expires=${d.toUTCString()}`;
    document.cookie = `${name}=${value}; ${expires}${
        path.length > 0 ? `; path=${path}` : ""
    }${domain.length > 0 ? `;domain=${domain}` : ""}`;
};